import { Controller } from '@hotwired/stimulus';
import { differenceInSeconds, parseISO } from 'date-fns';
import formatSeconds from '../utils/format_seconds';

export default class TestTimeupController extends Controller {
  static values = {
    endTime:   String,
    timeupUrl: String,
  };

  static targets = [
    'form',
    'remainingTime',
  ];

  timedUp = false;

  connect() {
    this.endTime = parseISO(this.endTimeValue);
  }

  tick({ detail: { now } }) {
    if (this.timedUp) { return; }

    const remainingSec = differenceInSeconds(this.endTime, now);

    if (remainingSec <= 0) {
      this.timedUp = true;

      for (const el of this.remainingTimeTargets) {
        el.textContent = '00:00:00';
      }

      this.formTarget.action = this.timeupUrlValue;

      const token = document.querySelector('input[name="authenticity_token"]');

      if (token) {
        token.value = document.querySelector('meta[name="csrf-token"]').content;
      }

      this.formTarget.submit();
    } else {
      for (const el of this.remainingTimeTargets) {
        el.textContent = formatSeconds(remainingSec);
      }
    }
  }
}
